// extracted by mini-css-extract-plugin
export default {"properties":"aurSJ","propertiesRow":"wW8zU"};